<template>
  <div class="mt-2">
    <span v-if="!isMariaCampaign" class="mf-h6 compor-email-title">Compor E-mail</span>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <p class="email-marketing-card-title">Assunto do e-mail</p>
            <v-tooltip top :disabled="disableTooltip">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-text-field
                    v-model="campaign.message.subject"
                    class="textarea"
                    placeholder="Assunto do e-mail"
                    outlined
                    no-resize
                    :error-messages="errorSubjectText"
                    :disabled="disabled"
                  />
                </div>
              </template>
              <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
              <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
            </v-tooltip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <mf-tabs-menu :key="componentKey" v-model="templateTab" :tabs="tabsMenuItems" class="my-4" />
    <v-container class="my-n2 px-0" :class="{ 'px-6': isMariaCampaign }" fluid>
      <simple-email-composer
        v-if="templateTab === 0"
        ref="simple-email-composer"
        :hasHeaderImg="hasHeaderImg"
        :hasBodyImg="hasBodyImg"
        :tryingToSaveAsDraft="tryingToSaveAsDraft"
        :campaign="campaign"
        :validations="validations"
        :disabled="disabled"
        :is-maria-campaign="isMariaCampaign"
        :is-maria-campaign-activated="isMariaCampaignActivated"
        :is-maria-campaign-finished="isMariaCampaignFinished"
        :header-image-url="headerImageUrl"
        :delete-header-image="deleteHeaderImage"
        :upload-header-image="uploadHeaderImage"
        :body-image-url="bodyImageUrl"
        :delete-body-image="deleteBodyImage"
        :upload-body-image="uploadBodyImage"
        @go-to-link="goToLink"
      />
      <builder-email-composer
        v-if="templateTab === 1"
        ref="builder-email-composer"
        v-model="campaign"
        :disabled="disabled"
        :validations="validations"
        :is-maria-campaign-activated="isMariaCampaignActivated"
        :is-maria-campaign-finished="isMariaCampaignFinished"
        :is-maria-campaign="isMariaCampaign"
      />
      <html-email-composer
        v-if="templateTab === 2"
        ref="html-email-composer"
        v-model="campaign"
        :disabled="disabled"
        :validations="validations"
        :is-maria-campaign-activated="isMariaCampaignActivated"
        :is-maria-campaign-finished="isMariaCampaignFinished"
      />
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'EmailTypesComposer',
  components: {
    BuilderEmailComposer: () => import('@/modules/campanhas/campanhas-email/views/components/BuilderEmailComposer.vue'),
    HtmlEmailComposer: () => import('@/modules/campanhas/campanhas-email/views/components/HtmlEmailComposer.vue'),
    SimpleEmailComposer: () => import('@/modules/campanhas/campanhas-email/views/components/SimpleEmailComposer.vue'),
  },
  props: {
    value: Number,
    tryingToSaveAsDraft: {
      type: Boolean,
      default: false,
    },
    isMariaCampaign: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    goToLink: {
      type: Function,
    },
    validations: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    headerImageUrl: {
      type: String,
      default: '',
    },
    deleteHeaderImage: {
      type: Function,
      default: () => {},
    },
    uploadHeaderImage: {
      type: Function,
      default: () => {},
    },
    bodyImageUrl: {
      type: String,
      default: '',
    },
    deleteBodyImage: {
      type: Function,
      default: () => {},
    },
    uploadBodyImage: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    openSendEmailPreviewDialog: false,
    componentKey: 0,
  }),
  computed: {
    templateTab: {
      get: function () {
        return this.value
      },
      set: async function (newValue) {
        this.componentKey += 1
        let ref = this.$refs[this.tabsMenuItems[this.templateTab].ref]
        if (ref?.isTouched()) {
          const confirmed = await this.$confirm({
            title: 'Tem certeza?',
            message: 'Qualquer alteração será perdida ao mudar de aba.',
            confirmText: 'Mudar',
            cancelText: 'Cancelar',
          })
            .then(() => true)
            .catch(() => false)
          if (!confirmed) {
            return
          }
        }
        this.campaign.message.processed_html = ''
        this.$emit('input', newValue)
      },
    },
    hasHeaderImg() {
      return Boolean(this.campaign && this.campaign.message.simple_email_configuration && this.campaign.message.simple_email_configuration.header_image)
    },
    hasBodyImg() {
      return Boolean(this.campaign && this.campaign.message.simple_email_configuration && this.campaign.message.simple_email_configuration.image)
    },
    tabsMenuItems() {
      return [
        {
          name: 'Simples',
          ref: 'simple-email-composer',
          disabled: this.disabled,
        },
        {
          name: 'Construtor',
          ref: 'builder-email-composer',
          disabled: this.disabled,
        },
        {
          name: 'HTML',
          ref: 'html-email-composer',
          disabled: this.disabled,
        },
      ]
    },
    errorSubjectText() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message
      if (this.validations.campaign?.shotConfiguration?.email) validations = this.validations.campaign.shotConfiguration.email.message

      if (!validations || !validations.subject) return ''
      if (validations.subject.$error) {
        if (!validations.subject.required) return 'Adicione um assunto para o e-mail.'
        else if (!validations.subject.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    disableTooltip() {
      if (!this.isMariaCampaign) return true
      return !this.disabled
    },
  },
  mounted() {
    this.$bus.$on('userflow-update-tab', () => {
      this.templateTab = 1
    })
  },
  destroyed() {
    this.$bus.$off('userflow-update-tab')
  },
  methods: {
    async getConfiguration() {
      const configs = await this.$refs[this.tabsMenuItems[this.templateTab].ref].getConfiguration()
      return configs
    },
  },
}
</script>

<style lang="scss">
.compor-email-title {
  font-size: 22px;
  color: $cinza-d10 !important;
  font-weight: bold;
}
</style>
